import { Button, ButtonProps } from "@mantine/core"
import { IconFileExport, IconPdf } from "@tabler/icons-react"

import { ButtonWithMenu } from "../Buttons/ButtonWithMenu/ButtonWithMenu.tsx"

export enum ExportType {
  CSV = "csv",
  PDF = "pdf",
}

interface ExportConfig {
  icon: JSX.Element
}

export const exportTypeConfig: Record<ExportType, ExportConfig> = {
  [ExportType.CSV]: {
    icon: <IconFileExport />,
  },
  [ExportType.PDF]: {
    icon: <IconPdf />,
  },
}

export type ExportOption<T = void> = {
  type: ExportType
  label: string
  exportFunction: (args: T) => void
  isLoading: boolean
  args?: T extends void ? undefined : T
}
type Props<T> = {
  label: string
  exportOptions: ExportOption<T>[]
  count?: number
} & React.ComponentProps<typeof Button> &
  React.ButtonHTMLAttributes<HTMLButtonElement> &
  ButtonProps

export const ExportButton = <T = void,>({
  label,
  exportOptions,
  count,
  ...props
}: Props<T>) => {
  const items = exportOptions.map((option) => {
    const { icon } = exportTypeConfig[option.type]
    return {
      icon,
      label: option.label,
      onClick: () => {
        option.exportFunction(option.args as T)
      },
    }
  })

  return (
    <>
      <ButtonWithMenu
        icon={<IconFileExport size={16} />}
        loading={exportOptions[0]?.isLoading}
        items={items}
        {...props}
      >
        {label}
        {count !== undefined ? ` (${count})` : ""}
      </ButtonWithMenu>
    </>
  )
}
